import { useState } from 'react';
import { Box, Card, Flex, Heading, IconButton, Menu, Portal } from '@chakra-ui/react';
import { LuEllipsisVertical } from 'react-icons/lu';
import { useAuthContext } from '@contexts/auth';
import CreatedBy from '@components/CreatedBy';
import type { SaleFunnelType } from '@customTypes/salesFunnels';

import ConfirmDisableDialog from './ConfirmDisableDialog';
import UpsertDialog from './UpsertDialog';

type Props = {
  saleFunnel: SaleFunnelType,
  refetch: () => void,
};

const FunnelCard = ({ saleFunnel, refetch }: Props) => {
  const { checkIfHasRole } = useAuthContext();

  const [showEditDialog, setShowEditDialog] = useState(false);
  const [showConfirmDisableDialog, setShowConfirmDisableDialog] = useState(false);

  const isEnabled = saleFunnel.is_enabled;

  const canManageSalesFunnels = checkIfHasRole('CAN_MANAGE_SALESFUNNELS');

  return (
    <Card.Root
      size="sm"
      variant="elevated"
      bg="grayscale.fg"
      mt={4}
      px={4}
      py={3}
    >
      <Flex justifyContent="space-between" alignItems="center" gap={2}>
        <Box>
          <Heading
            size="md"
            textDecoration={isEnabled ? 'none' : 'line-through'}
            color={isEnabled ? 'fg.default' : 'fg.error'}
          >
            {saleFunnel.name}
          </Heading>
          <CreatedBy user={saleFunnel.user} createdDate={saleFunnel.created_date} />
        </Box>
        {canManageSalesFunnels && (
          <Menu.Root>
            <Menu.Trigger asChild>
              <IconButton variant="ghost" size="sm">
                <LuEllipsisVertical />
              </IconButton>
            </Menu.Trigger>
            <Portal>
              <Menu.Positioner>
                <Menu.Content>
                  <Menu.Item value="edit" onClick={() => setShowEditDialog(true)}>
                    Editar
                  </Menu.Item>
                  {isEnabled && (
                    <Menu.Item
                      value="disable"
                      color="fg.error"
                      _hover={{
                        bg: "bg.error",
                        color: "fg.error"
                      }}
                      onClick={() => setShowConfirmDisableDialog(true)}
                    >
                      Desabilitar
                    </Menu.Item>
                  )}
                </Menu.Content>
              </Menu.Positioner>
            </Portal>
          </Menu.Root>     
        )}
      </Flex>

      {showEditDialog && (
        <UpsertDialog
          handleClose={() => setShowEditDialog(false)}
          afterSubmit={refetch}
          saleFunnel={saleFunnel}
        />
      )}
      {showConfirmDisableDialog && (
        <ConfirmDisableDialog
          saleFunnel={saleFunnel}
          handleClose={() => setShowConfirmDisableDialog(false)}
          afterSubmit={refetch}
        />
      )}
    </Card.Root>
  );
};

export default FunnelCard;
